import { environment } from 'src/environments/environment';
export const OAuthSettings = {
  appId: environment.config.microsoft.oauth.appId,
  redirectUri: environment.config.microsoft.oauth.redirectUri,
  scopes: environment.config.microsoft.oauth.scopes
};
